var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EquityDropdown, } from "@frameworks/web/components/generic/equitydropdown/equitydropdown";
import RefreshLabel from "@frameworks/web/components/generic/CountInput/RefreshLabel";
import React from "react";
import { Col, Row } from "react-bootstrap";
import InputField from "@frameworks/web/components/generic/inputField";
import BottomInputMsg from "@frameworks/web/components/features/TOC/CommonTocComponent/Stock/BottomInputMsg";
import ErrorExclamation from "@frameworks/web/components/generic/errorExclamation";
import { upiExp } from "@frameworks/web/utils/regex";
export var EUpiAction;
(function (EUpiAction) {
    EUpiAction["UPDATE_UPI_ID"] = "UPDATE_UPI_ID";
    EUpiAction["UPDATE_PRIMARY"] = "UPDATE_PRIMARY";
})(EUpiAction || (EUpiAction = {}));
var AddUpiIdFundTransfer = function (props) {
    var handleDataChange = function (action, val) {
        switch (action) {
            case EUpiAction.UPDATE_UPI_ID:
                props.setNewUpi(__assign(__assign({}, props.newUpiData), { upiId: val }));
                break;
            case EUpiAction.UPDATE_PRIMARY:
                props.setNewUpi(__assign(__assign({}, props.newUpiData), { isSetPrimary: val }));
                break;
            default:
                props.setNewUpi(__assign({}, props.newUpiData));
                break;
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "AddnewUpiSection" },
            React.createElement(Col, { lg: 12, className: "pt-3" },
                React.createElement(RefreshLabel, { title: "Bank Accounts", icon: false }),
                React.createElement(EquityDropdown, { selectedDefaultVal: props.selectedBank, itemlist: props.bankList, defaultVal: true, selectedValue: props.setSelectedBank, externalClassname: "common-new-drp new-upi-drp common-dropdown-toc", bigIcon: true, align: "start" }),
                React.createElement(BottomInputMsg, { message: "Primary Account", showlink: false })),
            React.createElement(Col, { lg: 12, className: "mt-4" },
                React.createElement(RefreshLabel, { title: "UPI ID", icon: false }),
                React.createElement(InputField, { className: "DMSanN_14_400", placeholder: "Enter UPI linked to above account", defaultValue: props.newUpiData.upiId, onChange: function (val) { return handleDataChange(EUpiAction.UPDATE_UPI_ID, val); }, placeholderClassName: "" })),
            React.createElement(Col, { lg: 12 },
                props.newUpiData.upiId.length > 0 &&
                    !upiExp.test(props.newUpiData.upiId) && (React.createElement(ErrorExclamation, { errorMessage: "UPI ID should be in the format name@bankname." })),
                React.createElement("div", { className: "d-flex align-items-center DMSansNormal_12_400 txt_primaryGrey pt-2 check-agree brdbottom-none" },
                    React.createElement("input", { className: "form-check-input", type: "checkbox", 
                        // value={props.newUpiData.}
                        id: "flexCheckDefault", checked: props.newUpiData.isSetPrimary, onChange: function (e) {
                            return handleDataChange(EUpiAction.UPDATE_PRIMARY, e.target.checked);
                        } }),
                    React.createElement("div", { className: "agree-button d-flex" }, "Make this as primary ID"))),
            React.createElement(ErrorExclamation, { parentClass: "errormsg-ft upi", avoidExclamation: true, errorMessage: "Press Proceed to verify the UPI ID by adding ₹50 to your funds." }))));
};
export default AddUpiIdFundTransfer;
